import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { CreateTrainingRequestActivity } from 'modules/trainings/activities/CreateTrainingRequest'
import { CreateTrainingRequestFromCatalogActivity } from 'modules/trainings/activities/CreateTrainingRequestFromCatalog'
import { DeleteSurveyActivity } from 'modules/trainings/activities/DeleteSurvey'
import { EditSurveySettingsActivity } from 'modules/trainings/activities/EditSurveySettings'
import { MyTrainingRequestActivity } from 'modules/trainings/activities/MyTrainingRequest'
import { SendSurveyActivity } from 'modules/trainings/activities/SendSurvey'
import { TrainingRequestActivity } from 'modules/trainings/activities/TrainingRequest'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  activities: {
    createTrainingRequest: {
      component: CreateTrainingRequestActivity,
      guidelines:
        'Opens the create training request wizard to submit a new training proposal from scratch. Use when the user wants to request a new training that is not in the catalog.',
    },
    createTrainingRequestFromCatalog: {
      component: CreateTrainingRequestFromCatalogActivity,
      guidelines:
        'Opens the create training request wizard to submit a training request by selecting from the existing training catalog. Use when the user wants to request a training from the catalog.',
    },
    sendSurvey: {
      component: SendSurveyActivity,
      guidelines:
        'Opens the send survey overlay to send a training survey to participants. Use when the user wants to send a training survey to employees or participants.',
      params: {
        trainingId: { guidelines: 'The ID of the training the survey belongs to.' },
        formId: { guidelines: 'The ID of the form (survey) to send.' },
      },
    },
    deleteSurvey: {
      component: DeleteSurveyActivity,
      guidelines:
        'Opens the delete training survey overlay to confirm deleting a survey from a training. Use when the user wants to delete a survey from a training.',
      params: {
        trainingId: { guidelines: 'The ID of the training the survey belongs to.' },
        formId: { guidelines: 'The ID of the form (survey) to delete.' },
      },
    },
    editSurveySettings: {
      component: EditSurveySettingsActivity,
      guidelines:
        'Opens the edit survey settings overlay to configure a training survey. Use when the user wants to edit settings or configure a training survey.',
      params: {
        trainingId: { guidelines: 'The ID of the training the survey belongs to.' },
        formId: { guidelines: 'The ID of the form (survey) to edit settings for.' },
      },
    },
    trainingRequest: {
      component: TrainingRequestActivity,
      guidelines:
        'Opens the training request detail panel to view and optionally approve or reject a training request. Use when a manager or approver wants to review a training request.',
      params: {
        id: { guidelines: 'The ID of the training request to view.' },
      },
    },
    myTrainingRequest: {
      component: MyTrainingRequestActivity,
      guidelines:
        'Opens the my training request detail panel to view or edit one of the current user own training requests. Use when the user wants to view, edit, or send a draft training request for approval.',
      params: {
        id: { guidelines: 'The ID of the training request to view or edit.' },
      },
    },
  },
} as const satisfies DomainManifest
